import useABTestValue from './useABTestValue'

export type useShowLouderDailyBriefing = () => ReturnType<
  typeof useABTestValue<'showLouderHomeSummary'>
>

const useShowLouderDailyBriefing = () =>
  useABTestValue('showLouderHomeSummary') === 'show'

export default useShowLouderDailyBriefing
